import { apiRequest } from '../api';
import { SALES_SUPPORT } from '../endPoints';

export const GET_ALL_CONTACTS = (
  metadataid,
  pageNo = 0,
  limit = 30,
  startDate,
  endDate,
  filterData,
  globalFilterValue,
) => {
  const params = {
    page: pageNo,
    limit,
  };

  if (startDate && endDate) {
    params.startDate = startDate;
    params.endDate = endDate;
  }

  if (globalFilterValue) {
    params.global = globalFilterValue;
  }

  if (filterData) {
    filterData.forEach(({ key, value }) => {
      params[key] = value;
    });
  }
  return apiRequest('get', SALES_SUPPORT.FETCH_CONTACTS(metadataid), null, params);
};

export const GET_MESSAGES = (metadataid, phone, lastMessageId = 0, limit = 30) => {
  const params = {
    lastMessageId,
    limit,
  };

  return apiRequest('get', SALES_SUPPORT.FETCH_MESSAGES(metadataid, phone), null, params);
};

export const POST_MESSAGE = (metadataid, data) => {
  return apiRequest('post', SALES_SUPPORT.SEND_MESSAGE(metadataid), data);
};

export const POST_REACTION = (metadataid, data) => {
  return apiRequest('post', SALES_SUPPORT.SEND_REACTION(metadataid), data);
};

export const POST_RESET_UNREAD_COUNT = (metadataid, phone) => {
  return apiRequest('post', SALES_SUPPORT.RESET_UNREAD_COUNTS(metadataid, phone));
};
export const INITIATE_CALL = (metadataid, phone, page = 0, limit = 10) => {
  const params = {
    page,
    limit,
  };

  return apiRequest('post', SALES_SUPPORT.INITIATE_CALL(metadataid, phone), null, params);
};

export const RECEIVE_CALL = (metadataid, phone, data) => {
  return apiRequest('post', SALES_SUPPORT.RECEIVE_CALL(metadataid, phone), data);
};

export const TERMINATE_CALL = (metadataid, phone, data) => {
  return apiRequest('post', SALES_SUPPORT.TERMINATE_CALL(metadataid, phone), data);
};
